import AsyncWelcomePage from "./landing"
import AsyncLoginPage from "./login"
import AsyncLoginWithEmailPage from "./login/email"
import AsyncLogoutPageFactory from "./logout"
import AsyncForgotPasswordPage from "./login/forgot_password"

import AsyncHomeActivityPage from "./home/activity"
import AsyncHomeNewsPage, { AsyncHomeEventsPage } from "./home/news"
import AsyncHomeNewsTagPostsPage from "./home/tag/posts"
import AsyncHomeNewsTagCirclesPage from "./home/tag/circles"
import AsyncHomePeoplePage from "./home/people"

import AsyncGroupsHomePage from "./groups"
import AsyncCreateGroupBasicsPage from "./groups/create/basics"
import AsyncCreateGroupPrivacyPage from "./groups/create/privacy"
import AsyncCreateGroupMembersPage from "./groups/create/members"
import AsyncCreateGroupSponsorPage from "./groups/create/sponsor"
import AsyncCreateGroupSchedulePage from "./groups/create/schedule"
import AsyncGroupsDiscoverPage from "./groups/discover"

import AsyncGroupPage from "./group"
import AsyncGroupInvitationPage from "./group/invite"
import AsyncGroupEditPage from "./group/edit"
import AsyncGroupMembersPage from "./group/membership/members"
import AsyncGroupInvitesPage from "./group/membership/invites"
import AsyncGroupAccessRequestsPage from "./group/membership/access_requests"

import AsyncNotificationsPage from "./notifications"

import AsyncTagEventPage from "./create/TagEvent"
import AsyncCreatePage from "./create/choose"
import AsyncComposePostPage from "./create/compose"
import AsyncTagPostPage from "./create/tag"
import AsyncPostAudiencePage from "./create/audience"
import AsyncSharePublishedPostPage from "./create/share"
import AsyncImportWordDocPage from "./create/import"

import AsyncPrivacyPage from "./privacy/AsyncPrivacyPage"
import AsyncTermsPage from "./privacy/AsyncTermsPage"
import AsyncPaymentSuccessPage from "./payment-success"
import AsyncPaymentCancelPage from "./payment-cancel"

import AsyncMyProfilePage from "./profile/AsyncMyProfilePage"
import AsyncMemberProfilePage from "./profile/AsyncMemberProfilePage"
import AsyncProfileDraftsPage from "./profile/drafts"
import AsyncProfileBookmarksPage from "./profile/bookmarks"
import AsyncProfileEditPage from "./profile/edit"
import AsyncViewPublishedPostPage from "./profile/posts/view/AsyncViewPublishedPostPage"

import AsyncGetStartedPage from "./register/tags"
import AsyncResetPasswordPage from "./register/reset-password"
import AsyncInvitationPage from "./register/invitation"
import AsyncChangeEmailPage from "./profile/change-email"
import AsyncInvitationPage2 from "./register/invitation2"
import AsyncEmailRegistrationPage from "./register/email"
import AsyncEmailPinConfirmationPage from "./register/confirm/pin"
import AsyncEmailTokenConfirmationPage from "./register/confirm/token"

import AsyncBookCairDesktopLivePage from "./book-cair-desktop"
import AsyncBookCairMobileLivePage from "./book-cair-mobile"
import AsyncBookCairBrowsePage from "./book-cair-browse"
import AsyncBookCairProfilePage from "./book-cair-profile"
import AsyncBookCairLibraryPage from "./book-cair-library"
import AsyncBookCairPurchasesPage from "./book-cair-purchases"
import AsyncBookCairDashboardPage from "./book-cair-dashboard"
import AsyncBookCairPaymentPage from "./book-cair-payment"
import AsyncBookCairPaymentResultPage from "./book-cair-payment-result"
import AsyncMushtarekLandingPage from "./mushtarek-landing"
import { NOT_FOUND } from "redux-first-router"

import { AsyncPagesFactories } from "navigation"
import MissingPage from "./MissingPage"
import AsyncEventPostPage, { AsyncEventRolesPage } from "./create/event/AsyncEventPostPage"

const pages: AsyncPagesFactories = {
  [NOT_FOUND]: MissingPage,
  "home/privacy": AsyncPrivacyPage,
  "home/terms": AsyncTermsPage,
  "home/payment-success": AsyncPaymentSuccessPage,
  "home/payment-cancel": AsyncPaymentCancelPage,
  "home/welcome": AsyncWelcomePage,
  "home/welcome/register": AsyncGetStartedPage,
  "home/welcome/register/email": AsyncEmailRegistrationPage,
  "home/welcome/register/email/confirm-with-pin": AsyncEmailPinConfirmationPage,
  "home/welcome/register/email/confirm-with-token": AsyncEmailTokenConfirmationPage,

  "home/welcome/login": AsyncLoginPage,
  "home/welcome/login/email": AsyncLoginWithEmailPage,
  "home/welcome/login/forgot-password": AsyncForgotPasswordPage,
  "home/welcome/logout": AsyncLogoutPageFactory,
  "home/welcome/reset-password": AsyncResetPasswordPage,
  "home/welcome/invitation": AsyncInvitationPage,
  "home/welcome/invitation2": AsyncInvitationPage2,
  "home/welcome/change-email": AsyncChangeEmailPage,


  "home/activity": AsyncHomeActivityPage,
  "home/news": AsyncHomeNewsPage,
  "home/events": AsyncHomeEventsPage,  
  "home/news/tag/posts": AsyncHomeNewsTagPostsPage,
  "home/news/tag/circles": AsyncHomeNewsTagCirclesPage,
  "home/people": AsyncHomePeoplePage,

  notifications: AsyncNotificationsPage,

  create: AsyncCreatePage,

  "groups/home": AsyncGroupsHomePage,
  "groups/_create/basics": AsyncCreateGroupBasicsPage,
  "groups/_create/privacy": AsyncCreateGroupPrivacyPage,
  "groups/_create/members": AsyncCreateGroupMembersPage,
  "groups/_create/sponsor": AsyncCreateGroupSponsorPage,
  "groups/_create/schedule": AsyncCreateGroupSchedulePage,
  "groups/discover": AsyncGroupsDiscoverPage,

  "groups/group/activity": AsyncGroupPage,
  "groups/group/outcome": AsyncGroupPage,
  "groups/group/posts": AsyncGroupPage,
  "groups/group/events": AsyncGroupPage,
  "groups/group/posts/post": AsyncViewPublishedPostPage,
  "groups/group/reference": AsyncGroupPage,
  "groups/group/groups": AsyncGroupPage,
  "groups/group/_edit": AsyncGroupEditPage,
  "groups/group/membership/members": AsyncGroupMembersPage,
  "groups/group/membership/invites": AsyncGroupInvitesPage,
  "groups/group/membership/invites/_create": AsyncGroupInvitationPage,
  "groups/group/membership/access_requests": AsyncGroupAccessRequestsPage,

  "profile/public/posts": AsyncMyProfilePage,
  "profile/public/posts/view": AsyncViewPublishedPostPage,
  "profile/public/events": AsyncMyProfilePage,
  "profile/public/responses": AsyncMyProfilePage,
  "profile/public/bio": AsyncMyProfilePage,
  "profile/drafts": AsyncProfileDraftsPage,
  "profile/drafts/_create/compose": AsyncComposePostPage,
  "profile/drafts/_edit/compose": AsyncComposePostPage,
  "profile/drafts/_edit/tag": AsyncTagPostPage,
  "profile/drafts/_editevent/tag": AsyncTagEventPage,
  "profile/drafts/_editevent/compose": AsyncComposePostPage,

  "profile/drafts/_edit/event": AsyncEventPostPage,
  "profile/drafts/_editevent/roles": AsyncEventRolesPage,
  "profile/drafts/_editevent/schedule": AsyncEventPostPage,

  "profile/drafts/_edit/audience": AsyncPostAudiencePage,
  "profile/drafts/_editevent/audience": AsyncPostAudiencePage,

  "profile/drafts/_edit/share": AsyncSharePublishedPostPage,
  "profile/drafts/_editevent/share": AsyncSharePublishedPostPage,

  "profile/drafts/_import/public": AsyncImportWordDocPage,
  "profile/drafts/_import/group": AsyncImportWordDocPage,
  "profile/drafts/respond": AsyncComposePostPage,
  "profile/bookmarks": AsyncProfileBookmarksPage,
  "profile/public/_edit": AsyncProfileEditPage,

  "home/member/posts": AsyncMemberProfilePage,
  "home/member/posts/post": AsyncViewPublishedPostPage,
  "home/member/events": AsyncMemberProfilePage,
  "home/member/responses": AsyncMemberProfilePage,
  "home/member/bio": AsyncMemberProfilePage,

  "live-book-cair-desktop": AsyncBookCairDesktopLivePage,
  "live-book-cair-mobile": AsyncBookCairMobileLivePage,
  "book-cair-browse": AsyncBookCairBrowsePage,
  "book-cair-profile": AsyncBookCairProfilePage,
  "book-cair-library": AsyncBookCairLibraryPage,
  "book-cair-purchases": AsyncBookCairPurchasesPage,
  "book-cair-dashboard": AsyncBookCairDashboardPage,
  "book-cair-payment": AsyncBookCairPaymentPage,
  "book-cair-payment-result": AsyncBookCairPaymentResultPage,
  "landing": AsyncMushtarekLandingPage,
}

export default pages
